export const Theme = {
  DARK: 'dark',
  LIGHT: 'light',
} as const

export type Theme = (typeof Theme)[keyof typeof Theme]

export const isTheme = (value: unknown): value is Theme => value === Theme.DARK || value === Theme.LIGHT
